import Axios from 'axios'

const urlCRUD = '/abm_cont_ejer'

export const crudGetLastAccountingDate = async () => {
	const response = await Axios.get(`${urlCRUD}/fechas`)
	return response.data
}
